import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export const HeroTestimonial = () => {
  const t = TESTIMONIALS[0];
  return (
    <section data-testid="hero-testimonial" className="bg-[#163d78] py-8">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-center sm:text-left">
        <div className="flex items-center gap-1 shrink-0">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={20} className="fill-[#ff6b70] text-[#ff6b70]" />
          ))}
        </div>
        <p className="text-base sm:text-lg font-medium text-white leading-relaxed">
          "{t.quote}"
          <span className="block sm:inline text-blue-200 text-sm font-normal sm:ml-2">— {t.author}, {t.company}</span>
        </p>
      </div>
    </section>
  );
};
